export const SENTRY_RELEASE: string | undefined = '144dc00614b1e7534768bcd4ee9538ce4e6cb493';
